var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 72,
    viewBox: "0 0 46 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_3362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2931 67.8427L21.3802 41.6515L4.11128 39.0453L34.7625 3.73648L23.6753 29.929L40.9442 32.5352L10.2931 67.8427Z",
    stroke: "white",
    strokeWidth: 2.56,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2931 67.8427L21.3802 41.6515L4.11128 39.0453L34.7625 3.73648L23.6753 29.929L40.9442 32.5352L10.2931 67.8427Z",
    fill: "url(#paint0_linear_130_3362)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_130_3362",
    x1: 27.5299,
    y1: 2.64495,
    x2: 17.5257,
    y2: 68.9343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C53EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07267C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_3362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.449,
    height: 67.04,
    fill: "white",
    transform: "translate(10.0044) rotate(8.58217)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRay);
export default __webpack_public_path__ + "static/media/ray.7f2f64d8909708e4e3c7910d308a5a96.svg";
export { ForwardRef as ReactComponent };